import { Settings } from 'luxon';

export default defineNuxtPlugin({
    name: 'datetime',
    dependsOn: ['i18n'],
    async setup(nuxtApp)
    {
        const { $settings, $i18n } = useNuxtApp();

        $settings('i18n').then((config: any) =>
        {
            Settings.defaultZone = 'local';
            Settings.defaultLocale = $i18n.shortLocale();
        });
    }
});
